import script from "./BodySubReviewMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./BodySubReviewMobile.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./BodySubReviewMobile.vue?vue&type=style&index=0&id=04df95fa&module=reviewMobile&lang=css"
cssModules["reviewMobile"] = style0
import "./BodySubReviewMobile.vue?vue&type=style&index=1&id=04df95fa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules],['__scopeId',"data-v-04df95fa"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QAvatar,QImg});
